<template>
  <div class="actions is-centered">
    <div
      class="modal"
      :class="{ 'is-active': modal }"
    >
      <div class="modal-background" />
      <div class="modal-content is-flex is-centered">
        <div class="box is-centered confirmation">
          <div class="field">
            <div class="label">
              ¿Estas seguro de eliminar esta pre factura?
            </div>
            <div class="control is-centered">
              <div class="field is-grouped">
                <p class="control">
                  <a
                    class="button is-success"
                    :class="{ 'is-loading': isLoading }"
                    :disabled="isLoading"
                    @click="deleteById"
                  >
                    <b-icon
                      size="is-small"
                      icon="check"
                    />
                    <span>
                      Sí
                    </span>
                  </a>
                </p>
                <p class="control">
                  <a
                    class="button is-danger"
                    :class="{ 'is-loading': isLoading }"
                    :disabled="isLoading"
                    @click="onCloseModal"
                  >
                    <b-icon
                      size="is-small"
                      icon="close"
                    />
                    <span>
                      No
                    </span>
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="onCloseModal"
      />
    </div>

    <AppRadialMenu
      :size="36"
      :item-size="48"
      :radius="80"
      :angle-restriction="50"
      :rotate="-25"
    >
      <AppRadialMenuItem
        v-if="sendToEdit"
        class="tooltip is-tooltip-info has-background-info has-text-white"
        data-tooltip="Editar Pre Factura"
      >
        <RouterLink
          class="action-option"
          :to="sendToEdit"
        >
          <BIcon
            icon="pencil"
            class="action-option-icon"
          />
        </RouterLink>
      </AppRadialMenuItem>

      <AppRadialMenuItem
        class="tooltip is-tooltip-danger has-background-danger has-text-white"
        data-tooltip="Eliminar pre factura"
      >
        <a
          class="action-option"
          @click="deleteInvoice"
        >
          <BIcon
            icon="cancel"
            class="action-option-icon"
          />
        </a>
      </AppRadialMenuItem>
    </AppRadialMenu>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'HistoryStampedActions',
  components: {
    AppRadialMenu: () => import(/* webpackChunkName: "app-radial-menu" */ '../../AppRadialMenu.vue'),
    AppRadialMenuItem: () => import(/* webpackChunkName: "app-radial-menu-item" */ '../../AppRadialMenuItem.vue'),
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    voucherType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      modal: false,
    };
  },
  computed: {
    sendToEdit() {
      switch (this.voucherType) {
        case 'I':
          return { name: 'InvoiceDetail', params: { uuid: this.id } };
        case 'T':
          return { name: 'TradeTransferDetail', params: { uuid: this.id } };
        default:
          return false;
      }
    },
  },
  mounted() {
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.modal) {
        this.modal = false;
      }
    }, false);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', () => {});
  },
  methods: {
    ...mapActions({
      deleteByUuid: 'invoice/deleteByUuid',
    }),
    deleteInvoice() {
      this.modal = true;
    },
    onCloseModal() {
      this.modal = false;
    },
    async deleteById() {
      this.isLoading = true;

      try {
        await this.deleteByUuid(this.id);

        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'La pre factura se eliminó satisfactoriamente.',
        });

        this.onCloseModal();
      } catch (error) {
        this.onCloseModal();

        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: `
            Ocurrió un error al tratar de eliminar la pre factura. <br>
            ${error.message}
          `,
        });
      }

      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.box.is-centered.confirmation {
  max-width: 400px;
}
</style>
